import { Field, Form, Formik } from 'formik';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as Yup from 'yup';
import { Select } from '../../../../../_metronic/_partials/controls';
import ChangedInfo from '../../../../components/ChangedInfo';

function UserEditForm(props) {
  const { intl, saveUser, user, actionsLoading, onHide } = props;
  // Validation schema
  const UserEditSchema = Yup.object().shape({
    name: Yup.string()
      .min(
        3,
        intl
          .formatMessage({ id: 'GENERAL.VALIDATION.MIN_LENGTH' })
          .replace('#value#', 3)
      )
      .max(
        50,
        intl
          .formatMessage({ id: 'GENERAL.VALIDATION.MAX_LENGTH' })
          .replace('#value#', 50)
      )
      .required(intl.formatMessage({ id: 'GENERAL.VALIDATION.REQUIRED' })),
    email: Yup.string()
      .email(intl.formatMessage({ id: 'GENERAL.VALIDATION.INVALID' }))
      .required(intl.formatMessage({ id: 'GENERAL.VALIDATION.REQUIRED' })),
    mobileNo: Yup.string()
      .min(
        8,
        intl
          .formatMessage({ id: 'GENERAL.VALIDATION.MIN_LENGTH' })
          .replace('#value#', 8)
      )
      .max(
        20,
        intl
          .formatMessage({ id: 'GENERAL.VALIDATION.MAX_LENGTH' })
          .replace('#value#', 20)
      ),
  });

  const roleOptionAdmin = intl.formatMessage({ id: 'USER.ROLE.ADMIN' });
  const roleOptionSVUser = intl.formatMessage({ id: 'USER.ROLE.SUPERVISOR' });
  const roleOptionUser = intl.formatMessage({ id: 'USER.ROLE.USER' });
  const statusOptionNew = intl.formatMessage({ id: 'USER.STATUS.NEW' });
  const statusOptionActive = intl.formatMessage({ id: 'USER.STATUS.ACTIVE' });
  const statusOptionInActive = intl.formatMessage({
    id: 'USER.STATUS.INCTIVE',
  });
  const statusOptionReActive = intl.formatMessage({
    id: 'USER.STATUS.REACTIVE',
  });
  const statusOptionBlocked = intl.formatMessage({ id: 'USER.STATUS.BLOCKED' });

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={user}
        validationSchema={UserEditSchema}
        onSubmit={(values) => {
          saveUser(values);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Modal.Body className='overlay overlay-block cursor-default'>
              {actionsLoading && (
                <div className='overlay-layer bg-transparent'>
                  <div className='spinner spinner-lg spinner-success' />
                </div>
              )}
              <Form className='form form-label-right'>
                <div className='form-group row'>
                  {/* Full Name */}
                  <div className='col-lg-4'>
                    <small className='form-text text-muted'>
                      <b>
                        <FormattedMessage id='USER.LABEL.NAME' />
                      </b>
                    </small>
                    <Field name='name' type='text' className='form-control' />
                  </div>
                  {/* Email */}
                  <div className='col-lg-4'>
                    <small className='form-text text-muted'>
                      <b>
                        <FormattedMessage id='USER.LABEL.EMAIL' />
                      </b>
                    </small>
                    <Field type='email' name='email' className='form-control' />
                  </div>
                  {/* MobileNo */}
                  <div className='col-lg-4'>
                    <small className='form-text text-muted'>
                      <b>
                        <FormattedMessage id='USER.LABEL.MOBILENO' />
                      </b>
                    </small>
                    <Field
                      name='mobileNo'
                      type='text'
                      className='form-control'
                    />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-lg-4'>
                    {/* Role */}
                    <small className='form-text text-muted'>
                      <b>
                        <FormattedMessage id='USER.LABEL.ROLE' />
                      </b>
                    </small>
                    <Select name='role' className='form-control'>
                      <option value='Admin'>{roleOptionAdmin}</option>
                      <option value='Supervisor'>{roleOptionSVUser}</option>
                      <option value='User'>{roleOptionUser}</option>
                    </Select>
                  </div>
                  {/* Status */}
                  <div className='col-lg-4'>
                    <small className='form-text text-muted'>
                      <b>
                        <FormattedMessage id='USER.LABEL.STATUS' />
                      </b>
                    </small>
                    <Select name='status' className='form-control'>
                      <option value='0'>{statusOptionNew}</option>
                      <option value='1'>{statusOptionActive}</option>
                      <option value='2'>{statusOptionInActive}</option>
                      <option value='3'>{statusOptionReActive}</option>
                      <option value='5'>{statusOptionBlocked}</option>
                    </Select>
                  </div>
                  <div className='col-lg-4'></div>
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <ChangedInfo
                value={{
                  createdByName: user.createdByName,
                  createdAt: user.createdAt,
                  updatedByName: user.updatedByName,
                  updatedAt: user.updatedAt,
                }}
              />

              <button
                type='button'
                onClick={onHide}
                className='btn btn-light btn-elevate'
              >
                <FormattedMessage id='GENERAL.BUTTON.CANCEL' />
              </button>
              <> </>
              <button
                type='submit'
                onClick={() => handleSubmit()}
                className='btn btn-primary btn-elevate'
              >
                <FormattedMessage id='GENERAL.BUTTON.SAVE' />
              </button>

              {/*  </div>
              </div> */}
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}

export default injectIntl(UserEditForm);
